import { IClientAllocationDetailed } from '~/services/api/clientAllocation/types';
import { ClientWithAllocation, NormalizedAllocations } from './types';

export const normalizeAllocationsByUser = (
  allocations: IClientAllocationDetailed[],
): NormalizedAllocations[] => {
  const usersMap = new Map<number, NormalizedAllocations>();

  allocations.forEach(allocation => {
    const { user, ...allocationData } = allocation;

    const existingUser = usersMap.get(user.id);

    const clientsWithAllocation = user.clients.map(client => ({
      ...client,
      allocation: allocationData,
    })) as ClientWithAllocation[];

    if (!existingUser) {
      usersMap.set(user.id, {
        id: user.id,
        userId: user.id,
        name: user.name,
        photo: user.photo,
        roles: user.roles,
        subRoles: user.subRoles,
        clients: clientsWithAllocation,
      });

      return;
    }

    existingUser.clients.push(...clientsWithAllocation);
  });

  return Array.from(usersMap.values());
};

export const getMemoByClientAndAllocation = (
  allocations: NormalizedAllocations[],
  clientId: number,
  allocationId: number,
  teamMemberId: number,
) =>
  allocations
    .find(alloc => alloc.userId === teamMemberId)
    ?.clients.find(c => c.id === clientId && c.allocation.id === allocationId)?.memo || '';

export default normalizeAllocationsByUser;
